// Field configuration for Category form
// Following the structure pattern from FieldRulesConfig.ts
import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface CategoryFormState {
  name: string
  slug: string
  description: string
  status: 'active' | 'inactive'
  parent_id?: string | null
  image_url_temp?: string
  image_id?: string
  meta_title?: string
  meta_keywords?: string
  meta_description?: string
}

export const categoryFields: (keyof CategoryFormState)[] = [
  'name',
  'slug',
  'description',
  'status',
  'parent_id',
  'image_url_temp',
  'image_id',
  'meta_title',
  'meta_keywords',
  'meta_description',
]

interface CategoryFieldsConfig extends FieldConfig<{
  name: FieldRules<CategoryFormState['name']>
  slug: FieldRules<CategoryFormState['slug']>
  description: FieldRules<CategoryFormState['description']>
  status: FieldRules<CategoryFormState['status']>
  parent_id: FieldRules<CategoryFormState['parent_id']>
  image_url_temp: FieldRules<CategoryFormState['image_url_temp']>
  image_id: FieldRules<CategoryFormState['image_id']>
  meta_title: FieldRules<CategoryFormState['meta_title']>
  meta_keywords: FieldRules<CategoryFormState['meta_keywords']>
  meta_description: FieldRules<CategoryFormState['meta_description']>
}> {}

interface CategoryFieldsConfigProps extends FieldRulesConfig<CategoryFormState> {}

export function categoryFieldsConfig(_props: CategoryFieldsConfigProps): CategoryFieldsConfig {
  return {
    fields: {
      name: {
        rules: {
          required: 'Name is required',
        },
      },
      slug: {
        rules: {
          required: 'Slug is required',
        },
      },
      description: {
        rules: {},
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
      parent_id: {
        rules: {},
      },
      image_url_temp: {
        rules: {},
      },
      image_id: {
        rules: {},
      },
      meta_title: {
        rules: {},
      },
      meta_keywords: {
        rules: {},
      },
      meta_description: {
        rules: {},
      },
    },
  }
}
